<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Summary Schedule</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><u>Filter by Description</u></label>
        <input type="text" [(ngModel)]="filterable.description" class="form-control" placeholder="enter description" />
      </div>
      <div class="col">
        <label for=""><u>Filter by State</u></label>
        <select [(ngModel)]="filterable.state" class="form-control" placeholder="State">
          <option value=null>-- select state --</option>
          <option *ngFor="let state of states" [ngValue]="state.value">{{state.name}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Type</u></label>
        <select [(ngModel)]="filterable.type" class="form-control" placeholder="Type">
          <option value=null>-- select type --</option>
          <option *ngFor="let type of types" [ngValue]="type.value">{{type.name}}</option>
        </select>
      </div>
      <div class="col ml-auto text-right  align-self-end">
        <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
        <button class="btn btn-danger btn-sm mr-2" (click)="clear()">Clear</button>
        <button class="btn btn-outline-success btn-sm text-dark font-weight-bold" (click)="openModal(newScheduleModal)" *ngIf="currentUser.roleName == 'ADMIN'">+ Schedule </button>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
</div>
<table id="scheduleList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>ID</th>
      <th>Description</th>
      <th>ShortCode</th>
      <th>Keyword</th>
      <th>Country</th>
      <th>Type</th>
      <th>From Day</th>
      <th>To Day</th>
      <th>Current Day</th>
      <th>State</th>
      <th>Error</th>
      <th>LastModified</th>
      <th>Operate</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="16">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="16">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let schedule of scheduleList; index as i;">
      <td>{{schedule.id}}</td>
      <td>{{schedule.description}}</td>
      <td>{{schedule.shortCode}}</td>
      <td>{{schedule.keyword}}</td>
      <td>{{schedule.country}}</td>
      <td>{{schedule.typeView}}</td>
      <td>{{schedule.fromDay}}</td>
      <td>{{schedule.toDay}}</td>
      <td>{{schedule.currentDay}}</td>
      <td>{{schedule.stateView}}</td>
      <td>{{schedule.error}}</td>
      <td>{{schedule.modifiedAt | date : 'yyyy-MM-dd HH:mm:ss'}}</td>
      <td>
        <button type="button" class="btn btn-sm btn-danger mr-2 mt-2" placement="top" ngbTooltip="Delete" (click)="deleteSchedule(schedule)"  *ngIf="currentUser.roleName == 'ADMIN'" [disabled]="schedule.state != 0">
          <i class="fas fa-trash"></i>
        </button>
        <button type="button" class="btn btn-sm btn-primary mr-2 mt-2" placement="top" ngbTooltip="Restart" (click)="restartSchedule(schedule)"  *ngIf="currentUser.roleName == 'ADMIN'" [disabled]="schedule.state != -1">
          <i class="fa fa-repeat" aria-hidden="true"></i>
          Restart
        </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="16" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
        <!-- <button (click)="setPage(2)">GO TO PAGE</button> -->
      </td>
    </tr>
  </tfoot>
</table>
<!-- </div> -->

<ng-template #newScheduleModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="newScheduleLabel">New Schedule</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" id="newSchedule-modal-body">
    <form [formGroup]="newScheduleForm" (ngSubmit)="onSubmit()">
      <small><i class="text-danger">* indicates mandatory field</i></small>
      <div class="form-group row p-2">
        <div class="col-sm-6">
          <label for=""><span class="text-danger">* </span><u>From Day:</u></label>
          <input type="date" class="form-control" formControlName="startDay" placeholder="From Day">
        </div>
        <div class="col-sm-6">
          <label for=""><span class="text-danger">* </span><u>To Day:</u></label>
          <input type="date" class="form-control" formControlName="toDay" placeholder="To Day">
        </div>
        <div class="col-sm-6">
          <label for="source" class="col-form-label"><span class="text-danger">* </span>Source: </label>
          <select formControlName="source" class="form-control" (ngModelChange)="changeSource($event)" placeholder="Source">
            <option *ngFor="let source of sourceList" [ngValue]="source">{{source.name}}</option>
          </select>
        </div>
        <div class="col-sm-6">
          <label for="country" class="col-form-label"><span class="text-danger">* </span>Country: </label>
          <select class="form-control" placeholder="Country" formControlName="country" (ngModelChange)="changeCountry($event)" >
            <option *ngFor="let country of countryList | keyvalue" [ngValue]="country.value">{{country.key}}</option>
          </select>
        </div>
        <div class="col-sm-6">
          <label for="name" class="col-form-label">ShortCode: </label>
          <ng-select [items]="shortCodeList" bindLabel="shortCode" (clear)="onClear()" placeholder="Select short code" formControlName="shortCode" class="form-control" >
          </ng-select>
        </div>
        <div class="col-sm-6">
          <label for="name" class="col-form-label"><span class="text-danger">* </span>Description: </label>
          <input type="text" class="form-control" formControlName="description" placeholder="Description">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.description.errors">
              The description cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <label for="name"class="col-form-label"><span class="text-danger">* </span>Summary Types: </label>
           <angular2-multiselect class="form-control" [data]="types"
                                [settings]="typeDropdownSettings" formControlName="summaryTypes">
          </angular2-multiselect>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.summaryTypes.errors">
               The summary types must be at least 1.
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
        <button type="submit" class="btn btn-primary" *ngIf="!processing">Add Schedule</button>
        <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
      </div>
    </form>
  </div>
</ng-template>
